import { CloseIcon, SearchIcon } from '@chakra-ui/icons';
import {
    Box,
    HStack,
    Input,
    InputGroup,
    InputLeftElement,
    InputRightElement,
} from '@chakra-ui/react';
import { useCallback } from 'react';
import { GrPowerReset } from 'react-icons/gr';
import { useSelector } from 'react-redux';

import { boxSearchStyling, searchStyling } from './agGridStyles';
import TableIconButton from './TableIconButton';

const AGGridSearchBar = ({
    quickFilterText,
    setQuickFilterText,
    refetch,
    extraComponents,
}) => {
    const onFilterTextBoxChanged = useCallback(
        (event) => {
            const { value } = event.target;
            setQuickFilterText(value);
        },
        [setQuickFilterText],
    );

    const { darkMode } = useSelector((state) => {
        return { ...state.settings };
    });

    const onRefetch = () => {
        refetch();
    };
    const handleClearSearch = () => {
        setQuickFilterText('');
    };

    return (
        <HStack
            sx={{
                borderTopRadius: 10,
                backgroundColor: darkMode ? '#1a1a1a' : '#EEE',
                justifyContent: 'space-between',
            }}>
            {!extraComponents ? <Box /> : extraComponents}
            <HStack
                paddingBottom="15px"
                paddingTop="15px"
                spacing={0}
                paddingRight="17px">
                <InputGroup sx={boxSearchStyling}>
                    <InputLeftElement
                        pointerEvents="none"
                        height="30px"
                        left="undefined"
                        right="200px">
                        <SearchIcon color="gray.300" />
                    </InputLeftElement>
                    <Input
                        type="text"
                        id="search-text-box"
                        placeholder="Search..."
                        sx={searchStyling}
                        color={darkMode ? 'dark.textDark' : null}
                        background={darkMode ? 'dark.bgDark' : null}
                        borderColor={darkMode ? 'dark.tcap-borderGray' : null}
                        onInput={onFilterTextBoxChanged}
                        value={quickFilterText}
                    />
                    {quickFilterText && (
                        <InputRightElement height="30px">
                            <CloseIcon
                                className="cursor-pointer"
                                onClick={handleClearSearch}
                                color="gray.300"
                            />
                        </InputRightElement>
                    )}
                </InputGroup>
                <TableIconButton
                    icon={<GrPowerReset />}
                    onClick={() => {
                        onRefetch();
                    }}
                />
            </HStack>
        </HStack>
    );
};

export default AGGridSearchBar;
